'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PanelContent = require('./PanelContent');

var _PanelContent2 = _interopRequireDefault(_PanelContent);

var _rcAnimate = require('rc-animate');

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var CollapsePanel = function (_Component) {
  _inherits(CollapsePanel, _Component);

  function CollapsePanel() {
    _classCallCheck(this, CollapsePanel);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CollapsePanel.prototype.handleItemClick = function handleItemClick() {
    this.props.onItemClick();
  };

  CollapsePanel.prototype.render = function render() {
    var _classNames2;

    var _props = this.props,
        className = _props.className,
        style = _props.style,
        prefixCls = _props.prefixCls,
        header = _props.header,
        headerClass = _props.headerClass,
        children = _props.children,
        isActive = _props.isActive,
        showArrow = _props.showArrow,
        destroyInactivePanel = _props.destroyInactivePanel;

    var headerCls = (0, _classnames2["default"])(prefixCls + '-header', _defineProperty({}, headerClass, headerClass));
    var itemCls = (0, _classnames2["default"])((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-item-active', isActive), _classNames2), className);
    return _react2["default"].createElement(
      'div',
      { className: itemCls, style: style },
      _react2["default"].createElement(
        'div',
        {
          className: headerCls,
          onClick: this.handleItemClick.bind(this),
          role: 'tab',
          'aria-expanded': isActive
        },
        showArrow && _react2["default"].createElement('i', { className: 'arrow' }),
        header
      ),
      _react2["default"].createElement(
        _rcAnimate2["default"],
        {
          showProp: 'isActive',
          exclusive: true,
          component: '',
          animation: this.props.openAnimation
        },
        _react2["default"].createElement(
          _PanelContent2["default"],
          {
            prefixCls: prefixCls,
            isActive: isActive,
            destroyInactivePanel: destroyInactivePanel
          },
          children
        )
      )
    );
  };

  return CollapsePanel;
}(_react.Component);

CollapsePanel.propTypes = {
  className: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].object]),
  children: _propTypes2["default"].any,
  openAnimation: _propTypes2["default"].object,
  prefixCls: _propTypes2["default"].string,
  header: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].number, _propTypes2["default"].node]),
  headerClass: _propTypes2["default"].string,
  showArrow: _propTypes2["default"].bool,
  isActive: _propTypes2["default"].bool,
  onItemClick: _propTypes2["default"].func,
  style: _propTypes2["default"].object,
  destroyInactivePanel: _propTypes2["default"].bool
};

CollapsePanel.defaultProps = {
  showArrow: true,
  isActive: false,
  destroyInactivePanel: false,
  onItemClick: function onItemClick() {},

  headerClass: ''
};

exports["default"] = CollapsePanel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-collapse/lib/Panel.js
// module id = 975
// module chunks = 0